
export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Apply for Access',
      description: 'Submit a short application to verify interest and financial readiness.',
      icon: 'ri-file-text-line'
    },
    {
      number: '2',
      title: 'Get Approved',
      description: 'Once qualified, you\'ll receive login credentials for the private marketplace.',
      icon: 'ri-shield-check-line'
    },
    {
      number: '3',
      title: 'Browse Active Listings',
      description: 'Explore AI agencies, SaaS tools, and infrastructure assets — blurred metrics until approved.',
      icon: 'ri-search-line'
    },
    {
      number: '4',
      title: 'Request Details',
      description: 'For approved users, we\'ll connect you directly with our deal team or asset broker.',
      icon: 'ri-team-line'
    }
  ];

  return (
    <section className="py-32 relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-6">
            How It <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent font-medium">Works</span>
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-px bg-gradient-to-r from-white/20 to-transparent z-0"></div>
              )}
              
              {/* Step Card */}
              <div className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 group-hover:scale-105 cursor-pointer">
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${step.icon} text-2xl text-blue-400`}></i>
                </div>

                {/* Number */}
                <div className="text-3xl font-light text-white/80 mb-4">{step.number}</div>

                {/* Title */}
                <h3 className="text-xl font-semibold mb-4 text-white">{step.title}</h3>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
